module.exports = __webpack_public_path__ + "static/media/YEDHQ-GUIbackground-S1.b0f3245e.png";